<template>
    <div class="all">
        <div class="screen">
            <h2 class="ovhidden">{{ planName }}<span class="ml20 fs16 fwl">筛选条件：{{ title }}</span></h2>
        </div>
        <div class="screen mt20" v-if="mediaType === 'govMedia' || mediaType === 'mainMedia'">
            <div class="item clearfix">
                <div class="fl">
                    <span class="name">情感属性</span>
                    <div class="screen-list">
                        <label class="checkbox-box" v-for="(item, index) in emotionList" :key="index">
                            <label class="checkbox-warp fl" :class="emotion.indexOf(item) != -1 ? 'curr' : ''">
                                <input class="checkbox" v-model="emotion" name="" type="checkbox" :value="item.name">
                                <i class="icons checkbox-icon"></i>
                            </label>
                            {{ item.name }}<span class="color-8a8a99">({{ item.num }})</span>
                        </label>
                    </div>
                </div>
                <div class="search-warp fr clearfix">
                    <span class="drop-down fl">
                        <button class="btn search-dropdown"><span class="text">{{ searchText[searchType] }}</span><i
                                class="icons"></i></button>
                        <ul class="option">
                            <li v-for="(item, index) in searchText" @click="searchSelect(index);" :key="index">{{ item }}</li>
                        </ul>
                    </span>
                    <button class="search-btn fr" @click="KeyUpEsc"><i class="icons search-icon"></i></button>
                    <div class="hidden"><input type="text" v-model.trim="keywords" @keyup.enter="KeyUpEsc"
                            :placeholder="searchPlaceholder[searchType]" class="input-text"></div>
                </div>
            </div>
            <div class="item clearfix">
                <span class="zu clearfix">
                    <span class="name">时间范围</span>
                    <div class="clearfix fl">
                        <div class="corm fl">
                            <a class="element" :class="{ curr: timeType === 5 }" href="javascript:void(0)"
                                @click="selectFixedTime(5);">24小时</a>
                            <a class="element" :class="{ curr: timeType === 0 }" href="javascript:void(0)"
                                @click="selectFixedTime(0);">今天</a>
                            <a class="element" :class="{ curr: timeType === 1 }" href="javascript:void(0)"
                                @click="selectFixedTime(1);">昨天</a>
                            <a class="element" :class="{ curr: timeType === 2 }" href="javascript:void(0)"
                                @click="selectFixedTime(2);">近三天</a>
                            <a class="element" :class="{ curr: timeType === 3 }" href="javascript:void(0)"
                                @click="selectFixedTime(3);">近七天</a>
                            <a class="element" :class="{ curr: timeType === 4 || timeType === 6 }" href="javascript:void(0)"
                                @click="selectFixedTime(4);">自定义</a>
                        </div>
                        <vue-datepicker-local v-if="timeType === 4 || timeType === 6" class="fl" v-model="timeRange"
                            format="YYYY-MM-DD HH:mm:ss" show-buttons :disabledDate="disabledDate"
                            @confirm="selectedDate" />
                    </div>
                </span>
            </div>
            <div class="item mt10 clearfix">
                <span class="name">媒体类别</span>
                <div class="screen-list">
                    <label class="checkbox-box" v-for="(item, index) in mediaDist" :key="index">
                        <label class="checkbox-warp fl" :class="mediaLevel.indexOf(item.name) != -1 ? 'curr' : ''">
                            <input class="checkbox" v-model="mediaLevel" name="" type="checkbox" :value="item.name">
                            <i class="icons checkbox-icon"></i>
                        </label>
                        {{ item.name }}<span class="color-8a8a99">({{ item.num }})</span>
                    </label>
                </div>
            </div>
            <div class="item mt10 clearfix">
                <span class="zu clearfix">
                    <span class="name">重复信息</span>
                    <span class="drop-down">
                        <button class="btn btn-lightblue"><span class="texts">{{ repeatList[collapse] }}</span><i
                                class="icons"></i></button>
                        <ul class="option">
                            <li v-for="(item, index) in repeatList" @click="selectRepeat(index)" :key="index">{{ item }}</li>
                        </ul>
                    </span>
                </span>
            </div>
        </div>
        <div class="warp mt20">
            <div class="warp-header">
                <div class="firle clearfix">
                    <div class="fl">
                        <label class="checkbox-box tion">
                            <label class="checkbox-warp fl"
                                :class="uuids.length === pageUuid.length && uuids.length > 0 ? 'curr' : ''">
                                <input class="checkbox" name="selectAll"
                                    :checked="uuids.length === pageUuid.length && uuids.length > 0 ? true : false"
                                    @click="checkAll($event)" type="checkbox" value="0">
                                <i class="icons checkbox-icon"></i>
                            </label>
                            全选
                        </label>
                        <span class="checkbox-box cp tion" @click="earlyWarning();">预警</span>
                        <!-- <span class="checkbox-box tion">删除</span> -->
                        <span class="checkbox-box cp tion" @click="downLoad(1);" title="下载当前所选数据">批量下载</span>
                        <span class="checkbox-box cp tion" @click="downLoad(6);" title="下载当前方案的所有数据">全部下载</span>
                    </div>
                </div>
            </div>
            <div class="warp-body clearfix">
                <div class="no-data" v-if="nodata"><span class="text">没有数据哦...</span></div>
                <ul class="article-list">
                    <li v-for="(item, index) in newsList" :key="index">
                        <div class="article-left fl">
                            <label class="checkbox-warp" :class="uuids.indexOf(item.newsId) != -1 ? 'curr' : ''">
                                <input class="checkbox" v-model="uuids" name="chooseInfo" type="checkbox"
                                    :value="item.newsId">
                                <i class="icons checkbox-icon"></i>
                            </label>
                        </div>
                        <div class="article-right fr">
                            <div class="article-btn">
                                <span class="collect" @click="collectFn(index);"
                                    :class="item.collectStatus === 0 ? '' : 'curr'"><i
                                        class="icons collect-icon"></i></span>
                                <!-- <span class="sign sign-blue">改</span> -->
                                <span class="sign sign-orange cp" :class="item.warningStatus === 0 ? '' : 'gray'"
                                    @click="earlyWarning(item.warningStatus, item.newsId);">警</span>
                                <span class="sign sign-blue cp" @click="oneClickCopy(index)">复</span>
                            </div>
                        </div>
                        <div class="article-mid">
                            <router-link class="color-3d3d4c" target="_blank"
                                :to="{ path: '/detail', query: { data: item.newsId + ',' + item.newsSimHash + ',' + startDate + ',' + endDate } }">
                                <h2 class="article-title ovhidden" :title="item.newsTitle"><span class="tag"
                                        :class="attributeType[item.newsEmotion]">{{ item.newsEmotion }}</span><span
                                        v-html="item.newsTitle"></span></h2>
                                <p class="ovhidden2 color-8a8a99" :title="item.newsDigest" v-html="item.newsDigest"></p>
                            </router-link>
                            <p class="ziduan color-8a8a99 mt10">
                                <span>时间：{{ item.newsPosttime }}</span>
                                <span>相似文章：<i class="color-blue"
                                        :class="item.simNum === '' ? 'load-sm' : ''">{{ item.simNum }}</i></span>
                                <span>发布平台：<i class="icons sm-icon"
                                        :class="icons[item.platform]"></i>{{ item.platformName }}</span>
                                <span>发布人：{{ item.mediaName }}</span>
                                <span v-if="item.mediaProvince != ''">发布地区：{{ item.mediaProvince }}</span>
                                <span v-if="item.newsContentIpLocation != ''">IP属地：{{ item.newsContentIpLocation }}</span>
                                <span>分析词：<i :class="item.keywords == '' ? 'load-sm' : ''"></i>{{ item.keywords }}</span>
                            </p>
                        </div>
                    </li>
                </ul>
                <!-- 分页 -->
                <page class="mt20" v-if="totalCount != ''" :currentPage.sync="page" :limit.sync="limit"
                    :totalCount="totalCount" @turn="getTableData"></page>
            </div>
        </div>
        <!-- 下载选项 -->
        <Dialog ref="downloadOption" title="下载字段自定义选择" btnText="下载" :callback="enterOption" type="normal" width="600">
            <div slot="mdBox">
                <h4 v-if="downloadTips != ''">tips:<span class="color-red">{{ downloadTips }}</span></h4>
                <div class="checkbox-group nolike clearfix">
                    <label class="checkbox-box">
                        <label class="checkbox-warp fl"
                            :class="selectOptionValue.length === selectOption.length ? 'curr' : ''"><input name=""
                                :checked="selectOptionValue.length === $parent.selectOption.length ? true : false"
                                type="checkbox" @click="optionCheckAll($event);" value="" class="checkbox"> <i
                                class="icons checkbox-icon"></i></label>
                        <div class="hidden ac">全选<span class="color-red">（为保证您的下载速度，请尽可能筛选必要的下载字段）</span></div>
                    </label>
                </div>
                <div class="checkbox-group nolike clearfix">
                    <label class="checkbox-box" v-for="(item, index) in selectOption" :key="index">
                        <label class="checkbox-warp fl"
                            :class="selectOptionValue.indexOf(item.type) != -1 ? 'curr' : ''"><input name=""
                                v-model="selectOptionValue" type="checkbox" :value="item.type" class="checkbox"> <i
                                class="icons checkbox-icon"></i></label>
                        <div class="hidden ac">{{ item.name }}</div>
                    </label>
                </div>
            </div>
        </Dialog>
        <!-- 下载提示 -->
        <!-- <Dialog ref="downloadModal" :callback="enterDownload" type="confirm">
            <div slot="mdBox">
                <p class="ac">是否确认下载</p>
            </div>
        </Dialog> -->
        <!-- 一键复制 -->
        <copy ref="copy" :text="copyHtml"></copy>
    </div>
</template>
<script>
import Dialog from '../../../components/dialog.vue'
import VueDatepickerLocal from 'vue-datepicker-local'
import city from '../../../components/city.vue';
import page from '../../../components/page.vue';
import copy from '../../../components/copy.vue';
export default {
    components: { VueDatepickerLocal, city, page, Dialog, copy },
    data() {
        const min = ''
        const max = ''
        return {
            copyHtml: '',
            attributeType: {
                '正面': 'tag-blue',
                '中性': 'tag-orange',
                '负面': 'tag-red',
            },//属性对应的class样式
            icons: {
                'wx': 'wx-icon',
                'web': 'web-icon1',
                'weibo': 'wb-icon1',
                'app': 'app-icon1',
                'bbs': 'bbs-icon1',
                'journal': 'bk-icon1',
                'media_toutiao': 'tt-icon1',
                'media_qq': 'qq-icon1',
                'media_baijia': 'bj-icon1',
                'media_sohu': 'sh-icon1',
                'media_wangyi': 'wy-icon1',
                'media_people': 'people-icon1'
            },
            pageData: [],//页面链接所有参数
            downloadTips: '',//全部下载提示
            selectOption: [],
            selectOptionValue: [],//已选择下载
            newsId: '',//新闻id
            page: 1,//页码
            limit: 20,//每页显示条数
            newsSimHash: '',
            totalCount: '',//总页数
            pageUuid: [],//单分页所有的uuid
            uuids: [],//选择的newsid数组
            planId: '',//方案ID
            planName: '',//方案ID
            newsList: [],//新闻列表
            watch: true,//是否监听
            title: '',//标题
            repeatList: ['不去重', '去重'],//相似文章
            collapse: 0,//去重type 0是不去重 1是去重
            downLoadType: '',//下载类型
            nodata: false,//暂无数据
            // 舆情总览政府和主流报道列表的少选参数
            timeRange: [],
            mediaType: '',//媒体类型
            timeType: 0,//时间乐类型
            mediaDist: [
                { name: "全部", num: 0 },
                { name: "央级媒体", num: 0 },
                { name: "省级媒体", num: 0 },
                { name: "市&以下媒体", num: 0 },
                { name: "商业媒体", num: 0 },
                { name: "行业媒体", num: 0 }
            ],//媒体列表
            mediaLevel: ['全部'],//选择的媒体
            keywords: '',
            searchPlaceholder: ['信息标题/内容/发布人查询', '请输入信息标题查询', '请输入信息内容查询', '请输入媒体发布人查询'],//搜索提示语
            searchText: ['全部', '标题', '内容', '发布人'],
            searchType: 0,//搜素是的分类
            emotionList: ['正面', '中性', '负面'],//情感字段
            emotion: ['正面', '中性', '负面'],
            startDate: '',
            endDate: '',
            timeFlag: true
        }
    },
    mounted() {
        let that = this;
        that.newsId = that.$route.query.id;//获取当前页面url的id
        that.startDate = this.$route.query.startDate;
        that.endDate = this.$route.query.endDate;
        if (this.$route.query.isRepeat) that.collapse = this.$route.query.isRepeat;
        if (this.$route.query.emotion) {
            if (this.emotion === '全部') {
                this.emotion = ['正面', '中性', '负面'];
            } else {
                this.emotion = [this.$route.query.emotion];
            }
        }
        // that.pageData = that.$route.query;
        if (that.$route.query.type === 'govMedia' || that.$route.query.type === 'mainMedia') {
            that.timeRange = [that.startDate, that.endDate];
            that.timeType = 4;
            that.getMediaLevel();
        } else {
            that.mediaLevel = that.$route.query.mediaLevel;
            that.keywords = that.$route.query.searchWords;
            that.getNewsList(0);
        }
    },
    created() {
        // 获取缓存方案数据
        this.mediaType = this.$route.query.type;
        this.planId = JSON.parse(sessionStorage.getItem('planStorage')).id;
        this.planName = JSON.parse(sessionStorage.getItem('planStorage')).name;
    },
    methods: {
        // 相似文章去重选择
        selectRepeat(index) {
            this.collapse = index;
            this.getMediaLevel()
        },
        // 获取新闻列表
        getNewsList(type) {
            let that = this;
            if (type === 0) {//非翻页
                that.page = 1;
            }
            let mediaLevel;
            if (Array.isArray(that.mediaLevel)) {
                mediaLevel = [...that.mediaLevel];
                for (let i = 0; i < that.mediaLevel.length; i++) {
                    if (that.mediaLevel[i] == '全部') {
                        mediaLevel.splice(i, 1);
                    }
                }
            } else {
                mediaLevel = that.mediaLevel;
            }
            let datas = {
                sid: that.planId,
                mediaLevel: mediaLevel,
                collapse: that.collapse,
                platformType: that.$route.query.platformType,
                pubArea: that.$route.query.pubArea,
                startDate: that.startDate,
                endDate: that.endDate,
                searchType: that.searchType,
                searchWords: that.keywords,
                type: that.$route.query.type,
                isFocus: that.$route.query.isFocus,
                emotion: that.emotion,
                newsContentIpLocation: that.$route.query.newsContentIpLocation,
                page: that.page,
                perpage: that.limit
            };
            that.uuids = [];
            that.$parent.loadModal(true, '正在获取数据...');
            that.$api.get('monitor/news-list/index', datas, r => {
                that.$parent.showLoad = false;
                console.log(r)
                that.$utils.returnCode(r, function () {
                    let data = r.data;
                    that.title = data.pageTitle;
                    that.emotionList = r.data.emotionDist;
                    // that.keywords = '';
                    if (data.list.length <= 0) {//没有数据
                        that.nodata = true;
                    } else {
                        that.nodata = false;
                    }
                    that.newsList = data.list;//新闻列表赋值
                    that.totalCount = data.total;
                    // that.newsSimHash = data.newsDetail.newsSimHash;
                    let pageUuid = [];
                    for (let i of data.list) {
                        pageUuid.push(i.newsId);
                    }
                    that.pageUuid = pageUuid;
                    // 调用获取分析词和相似文章
                    that.getSimilarArticle(data.list);
                });
            })
        },
        // 获取分析词和相似文章
        getSimilarArticle(data) {
            let that = this;
            if (data.length <= 0) {
                return;
            }
            let oldData = data;
            let simHash = [];
            let newsIds = [];
            let postDate = [];
            for (let i of data) {
                simHash.push(i.newsSimHash);
                newsIds.push(i.newsId);
                postDate.push(i.newsPostdate);
            }
            let datas = {
                startDate: that.$route.query.startDate,
                endDate: that.$route.query.endDate
            };
            that.$api.post('monitor/info/news-simnum', { simHash: simHash, newsId: newsIds, sid: that.planId, data: datas }, r => {
                that.$utils.returnCode(r, function () {
                    let datas = r.data;
                    for (let i of data) {
                        for (let j in datas) {
                            if (i.newsId === j) {
                                i.simNum = datas[j].simNum;
                            }
                        }
                    }
                    if (that.newsList === oldData) {
                        that.newsList = data;
                    }
                });
            })
            that.$api.post('monitor/info/news-keyword', { postDate: postDate, newsId: newsIds }, r => {
                that.$utils.returnCode(r, function () {
                    let datas = r.data;
                    for (let i of data) {
                        for (let j in datas) {
                            if (i.newsId === j) {
                                i.keywords = datas[j].keywords;
                            }
                        }
                    }
                    if (that.newsList === oldData) {
                        that.newsList = data;
                    }
                });
            })
        },
        // 全选状态
        checkAll(e) {
            let that = this;
            let checked = e.target.checked;
            that.uuids = [];
            if (checked == true) {
                that.uuids = that.pageUuid;//全选的时候 获取所有的uuid
            } else {
                that.uuids = [];
            }
        },
        // 下载
        downLoad(type) {
            let that = this;
            that.downLoadType = type;
            that.selectOptionValue = ['news_title', 'news_digest', 'news_author', 'media_name', 'news_origin_author_name', 'media_followers_count', 'news_url', 'platform_name', 'news_emotion', 'news_content_pubArea', 'news_posttime', 'media_pubArea'];
            let uuid = '';//全部下载为空
            if (type === 1) {//选择下载
                uuid = that.uuids;
                if (uuid.length <= 0) {
                    that.$utils.alertText('请选择需要下载的新闻');
                    return;
                }
            } else {
                if (that.newsList.length <= 0) {
                    that.$utils.alertText('暂无可下载数据');
                    return;
                }
            }
            let data = {
                type: type,
                sid: that.planId,
                data: {
                    uuid: uuid,
                    field: that.selectOptionValue,
                    type: that.$route.query.type,
                    searchWords: that.keywords,
                    mediaLevel: that.mediaLevel,
                    emotion: that.emotion,
                    platformType: that.$route.query.platformType,
                    pubArea: that.$route.query.pubArea,
                    startDate: that.startDate,
                    isFocus: that.$route.query.isFocus,
                    endDate: that.endDate,
                    newsContentIpLocation: that.$route.query.newsContentIpLocation,
                    collapse: that.collapse
                },
                pageUuid: that.pageUuid
            }
            that.$parent.loadModal(true, '请稍后...');
            that.$utils.getDownloadBefore(data, function (r) {
                that.downloadTips = r.msg;
                that.selectOption = r.data.fieldList;
                that.$refs.downloadOption.showMaskFun();
            }, function () {
                that.$parent.showLoad = false;
            })
        },
        // 确定下载字段
        enterOption() {
            let that = this;
            if (that.selectOptionValue.length <= 0) {
                that.$utils.alertText('请选择需要下载的字段');
                return;
            }
            let uuid = '';//全部下载为空
            let type = that.downLoadType;
            if (type === 1) {//选择下载
                uuid = that.uuids;
            }
            let data = {
                uuid: uuid,
                field: that.selectOptionValue,
                type: that.$route.query.type,
                searchWords: that.keywords,
                mediaLevel: that.mediaLevel,
                platformType: that.$route.query.platformType,
                pubArea: that.$route.query.pubArea,
                startDate: that.startDate,
                isFocus: that.$route.query.isFocus,
                endDate: that.endDate,
                newsContentIpLocation: that.$route.query.newsContentIpLocation,
                collapse: that.collapse
            };
            that.$parent.loadModal(true, '正在提交数据...');
            that.$api.post('monitor/info/download', { type: type, sid: that.planId, data: data }, r => {
                that.$parent.showLoad = false;
                that.$utils.returnCode(r, function () {
                    that.selectOptionValue = [];
                    that.$refs.downloadOption.closeMask();
                    that.$parent.alertTips('已添加到我的下载列表');
                },er => {
                  that.$parent.showLoad = false;
                });
            },er => {
              that.$parent.showLoad = false;
            })
        },
        // 下载字段全选
        optionCheckAll(e) {
            let that = this;
            that.selectOptionValue = [];
            let checked = e.target.checked;
            if (checked == true) {
                let selectOption = that.selectOption;
                for (let i of selectOption) {
                    that.selectOptionValue.push(i.type);
                }
            } else {
                that.selectOptionValue = [];
            }

        },
        // 翻页
        getTableData() {
            let that = this;
            that.getNewsList(1);
        },
        //收藏
        collectFn(index) {
            let that = this;
            let newsList = that.newsList;
            let sc = newsList[index].collectStatus;//获取收藏状态
            let url = sc === 0 ? 'user/index/collect' : 'user/index/cancel-collect';
            let uUid = newsList[index].newsId;
            let data = {
                type: 1,
                typeId: [uUid],
                sid: this.planId,
                typefrom: 'scheme',
            };
            that.$parent.loadModal(true, '正在提交数据');
            that.$api.post(url, { data: data }, r => {
                that.$parent.showLoad = false;
                that.$utils.returnCode(r, function () {
                    sc = sc === 0 ? 1 : 0;
                    newsList[index].collectStatus = sc;
                    that.$utils.alertText('操作成功');
                });

            })
        },
        // 预警
        earlyWarning(type, id) {
            let that = this;
            let isSupportArtificialWarningSet = that.$parent.isSupportArtificialWarningSet;//检测预警功能
            if (isSupportArtificialWarningSet != 1) {
                that.$parent.alertTips('对不起，你暂无使用预警功能的权限！');
                return;
            }
            let uuid = '';
            let url = '';
            if (id === undefined) {//批量预警
                url = 'monitor/warning/artificial-create';
                uuid = that.uuids;
            } else {
                uuid = [id];
            }
            if (type === 0) {//添加预警
                url = 'monitor/warning/artificial-create';
            } else if (type === 1) {//取消预警
                url = 'monitor/warning/artificial-delete';
            }
            if (uuid.length <= 0) {
                that.$utils.alertText('请选择需要预警的新闻');
                return;
            }
            if (this.timeFlag) {
                this.timeFlag = false
                let datas = {
                    sid: that.planId,
                    newsId: uuid,
                    articleType: 1
                };
                that.$parent.loadModal(true, '正在提交数据');
                that.$api.post(url, { data: datas }, r => {
                    that.timeFlag = true
                    that.$parent.showLoad = false;
                    that.$utils.returnCode(r, function () {
                        let newsList = that.newsList;
                        for (let i of uuid) {
                            for (let j of newsList) {
                                if (i === j.newsId) {
                                    if (type === 1) {//取消
                                        j.warningStatus = 0;
                                    } else {//预警
                                        j.warningStatus = 1;
                                    }
                                }
                            }
                        }
                        that.$utils.alertText(r.msg);
                    });
                })
            }

        },
        // 一键复制
        oneClickCopy(index) {
            let that = this;
            let text = that.newsList[index];
            this.copyHtml = '';
            let copyFields = JSON.parse(sessionStorage.getItem('planStorage')).copyFields;
            let copy = ''
            copyFields.forEach(it => {
                if (text[it.name] || !text[it.name]) {
                    if (text[it.name] != undefined && text[it.name] != '') {
                        copy += it.value + ':' + text[it.name] + '\n'
                    } else {
                        copy += it.value + ':暂无 \n'
                    }
                }
            })
            this.copyHtml = copy;
        },
        // 舆情总览政府和主流报道列表的特殊方案
        // 固定时间选择
        selectFixedTime(type) {//0是今天 1是昨天 2是近三天 3是近7天 4是自定义
            let that = this;
            that.dynamicTime(type);
            that.getMediaLevel();
        },
        // 动态获取时间
        dynamicTime(type) {
            let that = this;
            let nowTime = this.$utils.getNowDate();//今天时间
            let n = nowTime.split(' ')[1].split(':');//拆分当前时分秒
            let h = n[0];
            let m = n[1];
            let s = n[2];
            let min = '';
            let max = '';
            that.timeType = type;
            if (type != 4) {//非自定义
                if (type === 0) {
                    min = nowTime.split(' ')[0] + ' ' + '00:00:00';
                    max = nowTime;
                } else if (type === 1) {
                    let yesterday = this.$utils.getBeforeDay(nowTime, 1);//前一天
                    min = yesterday + ' ' + '00:00:00';
                    max = yesterday + ' ' + '23:59:59';
                } else if (type === 2) {
                    let ptd = this.$utils.getBeforeDay(nowTime, 2);//前三天
                    // min = ptd + ' ' + h + ':' + m + ':' + s;
                    min = ptd + ' ' + '00:00:00';
                    max = nowTime;
                } else if (type === 3) {
                    let psd = this.$utils.getBeforeDay(nowTime, 6);//前七天
                    // min = psd + ' ' + h + ':' + m + ':' + s;
                    min = psd + ' ' + '00:00:00';
                    max = nowTime;
                } else if (type === 5) {
                    let psd = this.$utils.getBeforeDay(nowTime, 1);//24小时
                    min = psd + ' ' + h + ':' + m + ':' + s;
                    max = nowTime;
                } else if (type === 6) {
                    let day = JSON.parse(sessionStorage.getItem('planStorage')).adjustDay;
                    that.initialTime(day);
                    return;
                }
                //进页面获取时间数据
                that.startDate = min
                that.endDate = max;
            } else {
                // let day = JSON.parse(sessionStorage.getItem('planStorage')).day;
                that.initialTime(7);
            }
        },
        // 获取当前时间和7天前时间
        initialTime(day) {
            let max = '';
            let min = '';
            let nowTime = this.$utils.getNowDate();
            let n = nowTime.split(' ');
            let n1 = n[0].split('-');
            let n2 = n[1].split(':');
            let oldTime = this.$utils.getBeforeDay(nowTime, day);
            let o = oldTime.split('-');
            max = new Date(n1[0], n1[1] - 1, n1[2], n2[0], n2[1], n2[2])
            min = new Date(o[0], o[1] - 1, o[2], n2[0], n2[1], n2[2])
            this.timeRange = [min, max];
            //进页面获取时间数据
            this.startDate = this.$utils.dateConversion(min, 1);
            this.endDate = this.$utils.dateConversion(max, 1);
        },
        // 媒体类别数据
        getMediaLevel() {
            let that = this;
            let datas = {
                sid: that.planId,
                startDate: that.startDate,
                endDate: that.endDate,
                searchWords: that.keywords,
                type: that.$route.query.type,
                searchType: that.searchType,
                emotion: that.emotion,
                collapse: that.collapse,
            };
            that.$api.get('monitor/news-list/media-level', datas, r => {
                that.$utils.returnCode(r, function () {
                    that.mediaDist = r.data;

                    that.getNewsList(0);
                });
            })
        },
        // 选择搜索分类
        searchSelect(value) {
            this.searchType = value;
        },
        // enter键搜索
        KeyUpEsc() {
            this.getMediaLevel();
        },
        disabledDate(time) {
            let day = this.$parent.timeSection;//获取当前用户的时间范围权限
            let nowTime = this.$utils.getNowDate();//今天时间
            let startDate = this.$utils.getBeforeDay(nowTime, day);//根据时间权限获取最早时间
            let n = nowTime.split(' ');
            startDate = startDate + ' ' + n[1]
            let number = this.$utils.dateToMillisecond(startDate);//将获取的最早时间转化成毫秒
            if (time.getTime() > new Date().getTime() || time.getTime() < number) return true;
        },
        //选择时间回调
        selectedDate(data) {
            let that = this;
            let flag = this.$utils.selectTime(data, this.$store.state.show.companyinfo.timeControlWindow)
            if (!flag) {
                return
            }
            that.watch = false;
            that.startDate = this.$utils.dateConversion(this.timeRange[0], 1);
            that.endDate = this.$utils.dateConversion(this.timeRange[1], 1);
            let day = that.$utils.getDateDiff(that.startDate, that.endDate);
            if (day > that.$parent.timeSection) {
                that.$utils.alertText('时间跨度最大限制' + that.$parent.timeSection + '天', '', 1500);
                return;
            }
            that.getMediaLevel();
        }
    },
    watch: {
        mediaLevel() {
            let that = this;
            let len = that.mediaLevel.length;
            if (that.mediaLevel[0] === '全部' && len > 1) {//选择非全部
                that.mediaLevel.splice(0, 1);
            } else if (that.mediaLevel[len - 1] === '全部' && len > 1) {
                that.mediaLevel = ['全部'];
            }
            that.getNewsList(0);
        },
        emotion() {
            this.getMediaLevel();
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/page/yuqingFenxi/propagationAnalysis/analysisDetail.vue